/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';
import {
  environment
} from '../../../environments/environment';
import {
  HttpClient,

} from '@angular/common/http';
import { SystemService } from '../../service/system.service';

@Injectable()
export class iccService {

  private dataModelUrl = '';


  constructor(private http: HttpClient) {
    let systemService = new SystemService();
    if (environment && environment.properties) {
      this.dataModelUrl = systemService.getDataModelUrl();
    }
  }

  getInboundCallCenterData(depId) {
    const url = `${this.dataModelUrl}cci_dashboard?sort={"_id":-1}&pagesize=1&filter={"department.id":${depId}}`;
    return this.http.get(url)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(reason => {
        console.error(reason);
        // return reason;
      })
  }
}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/icc/icc.service.ts